import { Component, OnInit } from '@angular/core';
import { DataApiService } from '../../../Services/data-api.service';
import { MAT_CHECKBOX_CLICK_ACTION, MatDialog } from '@angular/material';
import { AlertComponent } from '../alert/alert.component';


@Component({
  selector: 'app-codigo-descuento',
  templateUrl: './codigo-descuento.component.html',
  styleUrls: ['./codigo-descuento.component.scss']
})
export class CodigoDescuentoComponent implements OnInit {

  constructor(
    private dataApi:DataApiService,
    private dialog: MatDialog
  ) { }

  public form ={
    codigo:null,
    porcentaje:null,
    inicio:null,
    fin:null
  }

  onSubmit(){
    this.dataApi.crearCodigo(this.form).subscribe(
      data=>this.handleResponse(data)      
    )
  }
  handleResponse(data){    
    const dialogRef = this.dialog.open(AlertComponent,{
        width:"200px",
        panelClass:"alert-dialog-container",
        data:{mensaje:"Código ya creado con éxito"},
        disableClose: true,
        autoFocus:true
    }); 
    
  }
  ngOnInit() {
  }

}
